import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';

interface IComponentArrasteSolteQuestionAlternativa {
    codigo: number;
    text: string;
    correct: boolean;
    ordem: number;
}

class ComponentArrasteSolteQuestionAlternativa extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    text: string = '';

    @jsonProperty(Boolean)
    correct: boolean = false;

    @jsonProperty(Number)
    ordem: number = -1;

    fromJSON(json: IComponentArrasteSolteQuestionAlternativa, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.text = json.text;
        this.correct = json.correct;
        this.ordem = json.ordem;
        return this;
    }
}

export default ComponentArrasteSolteQuestionAlternativa;
